/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Field_Additional_Hosts_HintInputs */



/**
* | output |
* | --- |
* | "One host per line, for an API split across origins (a separate upload or download host)." |
*
* @param {External_Apis_Field_Additional_Hosts_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_field_additional_hosts_hint = /** @type {((inputs?: External_Apis_Field_Additional_Hosts_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Field_Additional_Hosts_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Host pro Zeile, für eine API, die über mehrere Ursprünge verteilt ist (etwa ein separater Upload- oder Download-Host).")
	return /** @type {LocalizedString} */ ("One host per line, for an API split across origins (a separate upload or download host).")
});